import { escapeHtml } from "./html_sanitizer"

// The row-action recipe for rows a Stimulus controller injects client-side.
// It must stay identical to the server-rendered rows (GlButtonsHelper
// gl_row_actions / gl_row_action_button) and to React RowActions.tsx
// (rowActionClassName) — HAML and React tables look the same
// (owner ruling 2026-09-30).
export const ROW_ACTION_CLASS = "gl-btn gl-btn-utility gl-btn-sm gl-row-action"
export const ROW_ACTION_DANGER_CLASS = `${ROW_ACTION_CLASS} gl-row-action--danger`
export const ROW_ACTIONS_STRIP_CLASS = "gl-row-actions"

// The reason a field row's Delete is disabled once values are stored under
// its key (Custom Fields, Database Fields). The server-rendered rows say the
// same thing (custom_fields/_field_actions, database_field_configs/index).
export const FIELD_HAS_DATA_DELETE_REASON = "Has saved values — archive it instead"

// One injected icon row action, the same markup gl_row_action_button renders.
// A `disabledReason` keeps the verb in its slot (DATATABLE-3: disable, never
// hide): disabled, the reason as its tooltip and in its accessible name
// ("<label> — <reason>"), and its own name as data-gl-gate-label / -tooltip
// for lib/gate_reason.js — the gl_row_action_button(disabled_reason:) shape.
export function rowActionButtonHtml({ icon, label, action, variant = null, disabledReason = null }) {
  const cls = variant === "danger" ? ROW_ACTION_DANGER_CLASS : ROW_ACTION_CLASS
  const state = disabledReason
    ? `disabled data-gl-tooltip="${escapeHtml(disabledReason)}" ` +
      `aria-label="${escapeHtml(`${label} — ${disabledReason}`)}" ` +
      `data-gl-gate-label="${escapeHtml(label)}" data-gl-gate-tooltip="${escapeHtml(label)}"`
    : `data-gl-tooltip="${escapeHtml(label)}" aria-label="${escapeHtml(label)}"`
  return `<button class="${cls}" type="button" ${state} data-action="${escapeHtml(action)}">` +
    `<i class="${escapeHtml(icon)}" aria-hidden="true"></i></button>`
}

// A field row's Delete: live while nothing is stored under the key, otherwise
// disabled with FIELD_HAS_DATA_DELETE_REASON.
export function fieldDeleteButtonHtml(action, hasData) {
  return rowActionButtonHtml({
    icon: "ph ph-trash", label: "Delete", action, variant: "danger",
    disabledReason: hasData ? FIELD_HAS_DATA_DELETE_REASON : null
  })
}
